<template>
  <b-modal id="modal-add-user" size="md" no-close-on-backdrop>
    <!-- custom modal title -->
    <template #modal-title>
      <div class="d-flex align-items-center">
        <feather-icon size="20" icon="UserPlusIcon" class="mr-05" />
        <span class="fs-18">Tambah User Baru</span>
      </div>
    </template>
    <!-- form container -->
    <loader-component v-if="is_loading" />
    <b-card no-body class="mb-0">
      <b-card-body>
        <validation-observer ref="biodataRules">
          <b-form>
            <!-- nama lengkap -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Nama Lengkap"
                rules="required"
              >
                <label for="nama-lengkap"
                  >Nama Lengkap <span class="text-danger">*</span>
                </label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserCheckIcon" />
                  </b-input-group-prepend>

                  <b-form-input
                    v-model="user_data.nama"
                    id="nama-lengkap"
                    placeholder="Masukkan Nama Lengkap"
                  />
                </b-input-group>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
            <!-- username -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Username"
                rules="required"
              >
                <label for="username">
                  Username <span class="text-danger">*</span>
                </label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="user_data.username"
                    id="username"
                    placeholder="Masukkan Username"
                    :focus="username_available"
                  />
                </b-input-group>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
                <small
                  v-if="username_available"
                  class="text-danger"
                  style="font-size: 10px"
                >
                  Username Telah Tersedia! Silahkan gunakan Username lain
                </small>
              </validation-provider>
            </b-form-group>
            <!-- password -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <label for="password">
                  Password <span class="text-danger">*</span>
                </label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="KeyIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="user_data.password"
                    id="password"
                    placeholder="Masukkan Password"
                    type="password"
                  />
                </b-input-group>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
            <!-- email -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Email"
              >
                <label for="email"> Email </label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="user_data.email"
                    id="email"
                    placeholder="Masukkan Email"
                  />
                </b-input-group>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
            <!-- role -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Role"
                rules="required"
              >
                <label for="role">
                  Role <span class="text-danger">*</span>
                </label>
                <select v-model="user_data.role" id="role" class="form-control">
                  <option value="null" disabled selected>
                    Pilih Role User
                  </option>
                  <option value="0">Super Admin</option>
                  <option value="1">Admin</option>
                  <option value="2">User</option>
                </select>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <!-- custom modal footer -->
    <template #modal-footer>
      <!-- button batal -->
      <b-button
        variant="outline-danger"
        size="sm"
        class="float-right mr-05"
        @click="cancelAddUser"
      >
        Batal
      </b-button>
      <!-- button simpan -->
      <b-button
        variant="outline-info"
        size="sm"
        class="float-right"
        @click.prevent="addNewUser"
      >
        Simpan
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import {
  BModal,
  VBModal,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
  BAlert,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import useJwt from "@/auth/jwt/useJwt";
import floating_loader from "@/views/components/floatingLoader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "addUser",
  components: {
    ValidationProvider,
    ValidationObserver,
    BModal,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    BAlert,
    "loader-component": floating_loader,
  },
  data() {
    return {
      is_loading: false,
      username_available: false,
      user_data: {
        nama: null,
        username: null,
        email: null,
        password: null,
        role: null,
      },
      //   validation
      required,
    };
  },
  created() {},
  methods: {
    addNewUser() {
      this.$refs.biodataRules.validate().then((success) => {
        if (success) {
          this.is_loading = true;
          this.username_available = false;
          let api = process.env.VUE_APP_API_URL + "users/save";
          let params = {
            nama: this.user_data.nama,
            username: this.user_data.username,
            email: this.user_data.email ? this.user_data.email : "-",
            password: this.user_data.password,
            role: this.user_data.role,
          };
          useJwt.axiosIns
            .post(api, { data: params })
            .then(() => {
              this.user_data = {
                name: null,
                username: null,
                email: null,
                password: null,
                role: null,
              };
              this.username_available = false;
              this.$bvModal.hide("modal-add-user");
              this.$parent.getData();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Berhasil",
                  icon: "CheckCircleIcon",
                  variant: "success",
                  text: `User berhasil ditambahkan`,
                },
              });
            })
            .catch(() => {
              this.username_available = true;
            })
            .finally(() => {
              this.is_loading = false;
            });
        }
      });
    },
    cancelAddUser() {
      (this.user_data = {
        name: null,
        username: null,
        email: null,
        password: null,
        role: null,
      }),
        this.$bvModal.hide("modal-add-user");
    },
  },
  directives: {
    "b-modal": VBModal,
  },
};
</script>
<style>
.modal-title {
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 20px !important;
  font-weight: bold;
}
</style>